/*
 * Free shipping bar — smooth fill animation.
 *
 * The bar is rendered in Liquid (snippets/free-shipping-bar.liquid) and already updates
 * on every cart change because the cart drawer re-renders via the Section Rendering API.
 * That re-render REPLACES the bar's DOM node, so the fill would otherwise snap to its new
 * width with no animation. This script slides it from the previous value to the new one.
 *
 * It listens for the theme's `cart-update` event and defers the work to the next frame with
 * requestAnimationFrame. That matters because the two cart flows publish the event at
 * different times relative to the DOM swap:
 *   - quantity change (cart.js): swap THEN publish
 *   - add to cart (product-form.js): publish THEN swap
 * Deferring a frame guarantees the freshly rendered bar is in the DOM in both cases.
 *
 * `subscribe` / `PUB_SUB_EVENTS` are global (constants.js + pubsub.js, loaded in <head>).
 */
(function () {
  var BAR_SELECTOR = '[data-free-shipping-bar]';
  var FILL_SELECTOR = '.free-shipping-bar__fill';
  var TRANSITION = 'width 0.4s cubic-bezier(0.33, 1, 0.68, 1)';

  function targetOf(bar) {
    return (bar.style.getPropertyValue('--fs-progress') || '0%').trim();
  }

  function animateBar() {
    requestAnimationFrame(function () {
      var bar = document.querySelector(BAR_SELECTOR);
      if (!bar) return;

      var fill = bar.querySelector(FILL_SELECTOR);
      if (!fill) return;

      var drawer = document.querySelector('cart-drawer');
      var to = targetOf(bar);
      var from = (drawer && drawer.dataset.fsLastProgress) || '0%';
      if (drawer) drawer.dataset.fsLastProgress = to;

      if (from === to) {
        fill.style.width = to;
        return;
      }

      // Pin the fill at the previous width with no transition, force the browser to
      // commit that state, then transition to the new width so it visibly slides.
      fill.style.transition = 'none';
      fill.style.width = from;
      void fill.offsetWidth; // reflow — commits the start state
      fill.style.transition = TRANSITION;
      fill.style.width = to;
    });
  }

  function seedLastProgress() {
    var bar = document.querySelector(BAR_SELECTOR);
    var drawer = document.querySelector('cart-drawer');
    if (bar && drawer && !drawer.dataset.fsLastProgress) {
      drawer.dataset.fsLastProgress = targetOf(bar);
    }
  }

  function init() {
    seedLastProgress();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, animateBar);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
